// 新版单点登录sdk将弃用由业务方拼路径参数配置的形式，改用传入appId动态读取业务方配置，同时新增了拥有埋点统计相关的功能
// 页面引入包
import { svgSsoPlus } from '@svg/sso-plus';

// eslint-disable-next-line import/no-mutable-exports
let ssoPlus;
const APP_ID = '2dja3ed3d5d4b92312sfadf2ccf6c121';

// 初始化实例
function initSSOPlus(clientExt) {
  const extCollectData = {
    pageTitle: window.location.href,
    upstreamSystem: 'designer_app_h5', // 上游系统（登录来源）
    isFromH5: 1, // 业务后端需要
    adSource: 'DSiteReg_H5',
    ...clientExt,
  };

  // 获取实例
  ssoPlus = svgSsoPlus({
    appId: APP_ID,
    env: process.env.VUE_APP_ENV,
    extCollectData,
  });
}

initSSOPlus();

/**
 * 跳转登录
 * @param {String} params 跳转链接
 */
function jumpToLogin(params) {
  if (!ssoPlus) {
    initSSOPlus();
  }
  ssoPlus
    .getSsoUrl({
      type: 'wap_login',
      params,
    })
    .then((loginUrl) => {
      window.location.href = loginUrl;
    });
}

function logout() {
  if (!ssoPlus) {
    initSSOPlus();
  }
  ssoPlus.toLogOut({
    appId: APP_ID,
  });
}

export {
  ssoPlus, initSSOPlus, jumpToLogin, logout,
};
